export default "__VITE_ASSET__f6983f91__"